import { Box } from '@betty/moonlight';
import { ShopItemType } from '../../state/items/items.types';
import Price from '../Price/Price';
import { memo, useMemo } from 'react';

function ShopItemPrice({ price, sale }: ShopItemType) {
  const [leftPrice, rightPrice] = useMemo(
    () => (sale ? [sale.price, price] : [price, null]),
    [price, sale],
  );

  return (
    <Box flexDirection="row" gap="space-200">
      <Price amount={leftPrice} />
      {rightPrice ? <Price amount={rightPrice} strikethrough /> : null}
    </Box>
  );
}

export default memo(ShopItemPrice);
